export const getCookie = name => {
  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1')}=([^;]*)`),
  );

  return matches ? decodeURIComponent(matches[1]) : null;
};

export const setCookie = (name, value, options = {}) => {
  const _options = { path: '/', expires: '', ...options };

  if (options.expires instanceof Date) {
    _options.expires = options.expires.toUTCString();
  }

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  Object.keys(_options).forEach(key => {
    cookie += `; ${key}`;
    const option = _options[key];
    if (option !== true) {
      cookie += `=${option}`;
    }
  });

  document.cookie = cookie;
};

export const getCookieOptions = () => {
  const expires = new Date();
  expires.setMonth(expires.getMonth() + 3);

  const domain = window.location.hostname === 'localhost' ? 'localhost' : `astondevs.ru`;

  return { expires, domain };
};
